export default __webpack_public_path__ + "static/media/cha_medic_purestream.02a353fe.png";